module.exports = __webpack_public_path__ + "img/central-map.81591d43.png";